import { FillInTheBlanksAreaPinComponentSettings } from '@lessonup/pins-shared';
import { color, cssBase as css, styled } from '@lessonup/ui-components';
import React from 'react';
import { CSSPropertiesWithVars } from '../../utils/pinComponents/tipTapStyles.types';
import { horizontalAlignmentToFlexValue } from '../TextPinComponent/TextPinComponent.utils';

export function computeFillInTheBlanksAreaPinComponentStyles(
  settings: FillInTheBlanksAreaPinComponentSettings
): CSSPropertiesWithVars {
  return {
    ...(settings.fontFamily && {
      '--component-fontfamily': `"${settings.fontFamily}"`,
    }),
    ...(settings.fontSize && { '--component-fontsize': settings.fontSize }),
    ...(settings.fontColor ? { '--component-fontcolor': settings.fontColor } : { '--component-fontcolor': '#001343' }), // ToDo: default color should eventually be set through templating
    '--component-fontweight':
      settings.fontWeight === 'bold' || settings.fontWeight === 'bold-italic' ? 'bold' : 'normal',
    '--component-fontstyle':
      settings.fontWeight === 'regular-italic' || settings.fontWeight === 'bold-italic' ? 'italic' : 'normal',
    lineHeight: settings.lineHeight ?? 1.5,
    '--component-paragraph-spacing': `${settings.paragraphSpacing ?? 0}em`,
    '--component-list-align': horizontalAlignmentToFlexValue(settings.horizontalAlignment),
    // The horizontal and vertical alignments need an explicit default so that the tiptap child always behaves the same way
    '--component-horizontal-align': settings.horizontalAlignment ?? 'left',
  };
}

// the pointer-events: none is needed to prevent the word from catching the mouse down event, this makes selecting the word really hard
export const blankNodeCss = css`
  position: relative;
  display: inline-block;
  border: 2px solid ${color.state.disabled.stroke};
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  background-color: ${color.neutral.surface.background};
  color: ${color.neutral.surface.text};
  border-radius: 0.25rem;
  text-align: center;
  line-height: 1.4;
  pointer-events: none;
`;

export const previewCss = css`
  min-width: 3em;
  background-color: ${color.neutral.surface2.background};
`;

const StyledAreaPinComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 4px;
`;

const StyledTipTapWrapper = styled.div`
  flex: 1;
  width: 100%;
  min-height: 0;
  margin-bottom: 4px;
  border-radius: 8px;
  overflow-y: auto;
`;

const StyledWordBankWrapper = styled.div`
  width: 100%;
  max-height: 40%;
  overflow-y: auto;
`;

export const AreaPinComponentWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <StyledAreaPinComponentWrapper>{children}</StyledAreaPinComponentWrapper>;
};

export const TipTapWrapper: React.FC<{ children: React.ReactNode; backgroundColor?: string }> = ({
  children,
  backgroundColor,
}) => {
  return <StyledTipTapWrapper style={{ backgroundColor }}>{children}</StyledTipTapWrapper>;
};

export const WordBankWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <StyledWordBankWrapper>{children}</StyledWordBankWrapper>;
};
